import React from 'react'
import StepButton from '../../common/StepButton'
import CustomRadioButton from "../../common/CustomRadioButton"
import {ReactComponent as BackArrow} from "../../../images/back_arrow.svg"
import "./productClientId.scss"

const ProductClientId = ({
handleClientIdChange,
submitClientIdResp,
clientIdVal,
isLoading,
handleNextResponse,
docError,
isCheckop,
handleclientback

}) => {
  return (
    <>
       <div className='clientIdMain maxWidth540 paddintTop80'>
          <div className='backArrowWrapper'>
            <BackArrow  onClick={()=>handleclientback()} />
          </div>
          <div className=''>
            <div className='clientIdSection'>
              <div className='questionHeader'>
                  <span className='question'>
                  Do you want the patient to add their ID documents?
                  </span>
              </div> 
              <div className='radioButtonSec'>
                  <div className='radioButtons'>
                    <div className='custBtn'>
                    
                      <CustomRadioButton
                          customLabel={"Yes"}
                            id={"yes"}
                          className="medium"
                          type="radio"
                          name="clientid"
                          value={"yes"}
                           checked={clientIdVal === "yes"}
                           onChange={(e) => handleClientIdChange(e)}
                          preselect={true}
                        />
                    </div>

                      <div className='custBtn'>
                       
                        <CustomRadioButton
                            customLabel={"No"}
                            id={"No"}
                            className="medium"
                            type="radio"
                            name="clientid"
                            value={"no"}
                           checked={clientIdVal === "no"}
                           onChange={(e) => handleClientIdChange(e)}
                          preselect={true}
                        />
                      </div>
                    
                    
                  </div>
              </div>
              <span className='answerError'>{docError}</span>
              <div className='buttonSection'>
                  <div className='buttons'>
                      <StepButton 
                        label={"Save & Next"}
                        blue={true}
                        className={"next-btn"}
                        onClick={() => {
                          handleNextResponse()
                        }}
                        isLoading={isCheckop === "next" && isLoading}
                      />
                  </div>
                  <div className='buttons'>
                      <StepButton 
                        label={"Submit for review"}
                        blue={true}
                        className={"next-btn"}
                        onClick={() => {
                          
                          submitClientIdResp()
                        }}
                        isLoading={isCheckop === "submit" && isLoading}
                      />
                  </div>
              </div>
            </div>
          </div>
       </div>
    </>
  )
}

export default ProductClientId